import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../barcodeform.css';

import Select from 'react-select';
import ReportIssueButton from './ReportIssueButton';

const BulkScan = () => {
  
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState('');
  const [shipmentDetails, setShipmentDetails] = useState([]); 
  const [loading, setLoading] = useState(false);

  // Handle the barcode scan (onChange or onKeyUp event)
  const handleBarcodeInputChange = (event) => {
    setBarcode(event.target.value);
  };

 

  
  const handleBarcodeKeyDown = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault(); // Prevents form submission or unwanted behavior
        const scannedValue = barcode.trim();
        
        if (scannedValue) {
            processBarcode(scannedValue);
            setTimeout(() => setBarcode(''), 100); // Allow time for barcode to register
        }
    }
};

const processBarcode = (scannedValue) => {
  

         const scannedBarcodes = scannedValue
  .split(/[\n,]+/)
  .map(value => value.trim()) // ✅ Trim each value first
  .filter(value => value !== '') // ✅ Remove any empty strings
  .map(value => {
    if (value.startsWith('EKX')) {
      // Remove first 3 characters and last 5 characters
      return value.slice(3, -5);
    }
    return value;
  });

    setShipmentDetails((prevDetails) => [...prevDetails, ...scannedBarcodes]);
};


  const buttonsyle={
    background: '#00a6ed',
    color: '#fff',
    padding: '3px',
    marginRight: '10px',
    borderColor:'#00a6ed',
    cursor:'pointer',
    marginTop:'3%'
}

  // Fetch shipment details from backend



   useEffect(() => {
          // Fetch drivers from the API on component mount
           fetchDrivers();
          getHomebase()
      }, []);
  
  const [scaninfo, setScaninfo] = useState({
    homebase:'',
    driver:'',
    scan_date:'',
    scan_time:'',
    failureReason:'',
    image:'',
    expctd_dlv_dt:'',
    reasn_for_return:'',
    item_desc:''

  })
  const [drivers, setDrivers] = useState()
  const [awb, setAwb] = useState([]);

  const [homebases, sethomebases] = useState([])
  const getHomebase = async () => {
      const API_PATH =  `${API_URL}shypvdriverapp/homebase/getHomebases`;
      
      try {
          const res = await axios.get(API_PATH);
          console.log(res.data);
          if(res.data.success==true){
            sethomebases(res.data.data);
          }else{
              console.log('false')
          }
         
      } catch (err) {
          console.log(err);
      }
  };


  console.log('homebases', homebases)
  const fetchDrivers = async () => {
    try {
        // Replace this API endpoint with the actual one that fetches drivers based on the emirate
        const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

        if (response.data.success) {
            const driversData = response.data.data;  // The array of driver objects

            // Map the response to extract driverId and name
            const driversList = driversData.map(driver => ({
                driver_id: driver.driverId,
                driver_name: driver.name
            }));

            // Set the drivers state
            setDrivers(driversList);
        } else {
            console.error('Error fetching drivers for emirate:');
        }
    } catch (error) {
        console.error('Error fetching drivers:', error);
    }
};


const [allStatus, setallStatus] = useState()
useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
      .then((response) => {
        setallStatus(response.data.data);  // Store the data in state
        setLoading(false);        // Set loading to false when done
      })
      .catch((err) => {
        setError(err);            // Store the error in state if something goes wrong
        setLoading(false);        // Set loading to false even if there's an error
      });
  }, []); 


  
const [allExceptions, setallExceptions] = useState()
useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllExceptionStatus`)
      .then((response) => {
        setallExceptions(response.data.data);  // Store the data in state
        setLoading(false);        // Set loading to false when done
      })
      .catch((err) => {
        setError(err);            // Store the error in state if something goes wrong
        setLoading(false);        // Set loading to false even if there's an error
      });
  }, []); 

console.log('scan:',scaninfo)
const [msg, setMsg] = useState()
const [errorMsg, setError] = useState()

function doBulkScan() {
  if (scaninfo.driver && scaninfo.scan_date && scaninfo.scan_time && scaninfo.status)  {

  
    setError('');
    setMsg('');

    // Create a new FormData object
    const formData = new FormData();
    formData.append('scan_date', scaninfo.scan_date);
    formData.append('scan_time', scaninfo.scan_time);
    formData.append('driver_id', scaninfo.driver);
    formData.append('status', scaninfo.status);
    formData.append('updated_by', sessionStorage.getItem('userid'));
    formData.append('failed_reason', scaninfo.failureReason);
    formData.append('expctd_dlv_dt', scaninfo.expctd_dlv_dt);
    formData.append('item_desc', scaninfo.item_desc);
    formData.append('reasn_for_return', scaninfo.reasn_for_return);
      formData.append('home_base', scaninfo.homebase);

   
    // formData.append('awbs', shipmentDetails);
    const awbString = shipmentDetails.join(',');
formData.append('awbs[]', awbString);

    // formData.append('awbs', JSON.stringify(shipmentDetails));
    formData.append('POD_image', scaninfo.image);
    // Append the image (if it's present)
    // if (scaninfo.image) {
    //   formData.append('POD_image', scaninfo.image);  // Here you append the actual file
    // }

    // For debugging, log the formData content (Note: formData doesn't log like regular objects, so we need to inspect its entries)
    console.log('FormData entries:' ,formData);
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }

    setMsg('Processing...');

    // Make the POST request with the FormData
    axios.post(`${API_URL}shypvdriverapp/jobs/updateMultipleAwbs`, formData)
      .then(response => {
        console.log("Response:", response.data);

        // Initialize success flag
        let allSuccess = true;
        let errorMessages = [];

        // Loop through each AWB in the response data
        response.data.data.forEach(item => {
          const awb = item.awb;
          const status = item.orderDetails[0]?.status;

          // Accumulate error messages for failures
          errorMessages.push(`${awb}: ${status}.`);
          allSuccess = false;
        });

        // If all updates are successful, show success message
        if (allSuccess) {
          setMsg('Status Updated');
        } else {
          setMsg(errorMessages.join('\n'));
          // setError(errorMessages.join(' '));  // You can uncomment this line if you want to set an error as well
        }
      })
      .catch(error => {
        console.error("Error:", error);
        setMsg('Something went wrong. Please try again.');
        setError('Something went wrong. Please try again.');
      });
  } else {
    setError('Please enter all the required fields');
  }
}



const handleDelete = (awbToDelete) => {
  // Filter out the AWB to delete
  const updatedDetails = shipmentDetails.filter((awb) => awb !== awbToDelete);
  setShipmentDetails(updatedDetails);
};


const handleStatusChange = (e) => {
  const status = e.target.value;
  // setScaninfo({ ...scaninfo, status });

  if (status === "DELIVERED") {
    setScaninfo({ 
      ...scaninfo, 
      status,
      failureReason: "",  // Empty failed_reason
    });
  }
  // If status is "Failed", clear the POD_image
  else if (status === "FAILED") {
    setScaninfo({ 
      ...scaninfo, 
      status,
      image: null,  // Empty POD_image (set to null or "" based on your needs)
    });
  } else {
    // For other statuses, just update the status
    setScaninfo({ 
      ...scaninfo, 
      status 
    });
  }
  // You can add additional logic here if necessary
};

console.log('scaninfo : ',scaninfo)

const [searchQuery, setSearchQuery] = useState("");

   const filteredDrivers = Array.isArray(drivers) 
        ? drivers.filter(driver =>
            driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : [];

        const driverOptions = filteredDrivers.map(driver => ({
        value: driver.driver_id,
        label: `${driver.driver_id} - ${driver.driver_name}`
    }));

     const handleChange = (selectedOption) => {
        setScaninfo({ ...scaninfo, driver: selectedOption.value });
    };
  return (
    <div>
      <ReportIssueButton pageContext="BULKSCAN" pageLabel="Bulk Scan" awb={barcode} />
      <div className="form-container">
        <div className="row">
        <div className="col-md-6">
        <h5 style={{float:'left'}}>Bulk Scan</h5>
        </div>
        </div>
     
            <div className="row">
             
              <div className="col-md-7">
              
                <div className="row">
                  <div className="col-md-6"> <div className="form-group">
              <label htmlFor="date">Date:</label>
              <input
                type="date"
                id="date"
                onChange={(e) => setScaninfo({ ...scaninfo, scan_date: e.target.value })}
                value={scaninfo.scan_date}

              />
            </div></div>
                  <div className="col-md-6">

                     <div className="form-group">
              <label htmlFor="time">Time:</label>
              <input
                type="time"
                id="time"
                onChange={(e) => setScaninfo({ ...scaninfo, scan_time: e.target.value })}
                value={scaninfo.scan_time}

              />
            </div>
                  </div>
                </div>
             
          
<div className="row">
  <div className="col-md-6">
 <div className="form-group">
            <label htmlFor="driver">Select Driver:</label>
            <Select
                options={driverOptions}
                value={driverOptions.find(option => option.value === scaninfo.driver)}
                onChange={handleChange}
                placeholder="Select a driver"
                onInputChange={newValue => setSearchQuery(newValue)} // Update search query
                isSearchable
                noOptionsMessage={() => "No drivers found"}
            />
        </div>
  </div>
  <div className="col-md-6">
    {/* disabled={status === 'DELIVERED'} */}
      <div className="form-group">
                    <label htmlFor="driver">Select Status:</label>
                    <select
                        id="driver"
                        value={scaninfo.status}
                        onChange={handleStatusChange}
                        
                    >
                        <option value="">Select a status</option>
                        {allStatus && allStatus
    .filter(status => !(allExceptions || []).includes(status)).map((status, i) => (
                                                                <option key={i} value={status}
                                                                 >
                                                                    {status}
                                                                </option>
                                                            ))}
                    </select>
                </div>
  </div>
</div>
           


                
            
                
               
              

                {scaninfo.status === 'DELIVERED' && (
                <div className="form-group">
                    <label htmlFor="imageUpload">Upload Image:</label>
                    <input
                        type="file"
                        id="imageUpload"
                        onChange={(e) => setScaninfo({ ...scaninfo, image: e.target.files[0] })}
                    />
                </div>
            )}

            {scaninfo.status === 'PICKED_UP' && (<>
            <div className="row">
              <div className="col-md-4">
                 <div className="form-group">
                    <label htmlFor="imageUpload">Item Description:</label>
                    <input
                        type="text"
                        id="item_desc"
                        onChange={(e) => setScaninfo({ ...scaninfo, item_desc: e.target.value })}
                    />
                </div>
              </div>
              <div className="col-md-4">
  <div className="form-group">
                    <label htmlFor="imageUpload">Reason for return:</label>
                    <input
                        type="text"
                        id="reason"
                        onChange={(e) => setScaninfo({ ...scaninfo, reasn_for_return: e.target.value })}
                    />
                </div>
              </div>
              <div className="col-md-4">
  <div className="form-group">
                    <label htmlFor="imageUpload">Expected Delivery Date</label>
                    <input
                        type="date"
                        id="expctd_dlv_dt"
                        onChange={(e) => setScaninfo({ ...scaninfo, expctd_dlv_dt: e.target.value })}
                    />
                </div>
              </div>
            </div>
               
              
                </>
            )}

            {/* Conditional render for "Failed" status */}
            {scaninfo.status === 'FAILED' && (
                <div className="form-group">
                    <label htmlFor="failureReason">Select Failure Reason:</label>
                    <select
                        id="failureReason"
                        value={scaninfo.failureReason}
                        onChange={(e) => setScaninfo({ ...scaninfo, failureReason: e.target.value })}
                    >
                        <option value="">Select a reason</option>
                        {allExceptions && allExceptions.map((reason, i) => (
                            <option key={i} value={reason}>
                                {reason}
                            </option>
                        ))}
                    </select>
                </div>
            )}

                <div className="form-group">
                    <label htmlFor="driver">Select Homebase:</label>
                    <select
                        id="driver"
                        value={scaninfo.homebase}
                        onChange={(e) => setScaninfo({ ...scaninfo, homebase: e.target.value })}
                        
                    >
                        <option value="">Select a Homebase</option>
                        {homebases&& homebases.map((homebase) => (
                            <option key={homebase.homebaseCode} value={homebase.homebaseCode}>
                                {homebase.homebaseName}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Barcode Input */}
                <div className="form-group">
                <label htmlFor="driver">AWB:</label>
                 
                    
<textarea
          id="driver"
          value={barcode}
                        onChange={handleBarcodeInputChange}
                        // onKeyUp={handleBarcodeKeyUp}
                        onKeyDown={handleBarcodeKeyDown}
                        placeholder="Scan barcode and press Enter"
          autoFocus
          style={{ minHeight: '120px', width: '100%' }}
        />
                </div>

               
          
              </div>
              <div className="col-md-4">
  {loading && <p>Loading shipment details...</p>}

  {shipmentDetails.length > 0 && (
    <div>
      <h3>Shipment Details:</h3>
      <div className="shipdata"  style={{
        background: '#5583af59',
        maxHeight: '400px', // Adjust the height limit as needed
        overflowY: 'auto',  // Enables vertical scrolling
        padding: '10px',   // Optional: Add some padding for better visuals
        border: '1px solid #ccc' // Optional: Add a border for separation
      }}>
              {shipmentDetails.map((awb, index) => (
        

<div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', width: '100%' }}>
<p style={{ 
  textAlign: 'left', 
  marginRight: '10px', 
  marginBottom: '0', 
  flex: 1,  // Ensures <p> takes up remaining space
  overflow: 'hidden', // To handle long text gracefully
  textOverflow: 'ellipsis'  // To truncate overflowed text with "..."
}}>
  {awb}
</p>
<a
  style={{
    color: 'red', 
    cursor: 'pointer', 
    marginLeft: '10px',
    flexShrink: 0  // Prevent the delete icon from shrinking
  }}
  onClick={() => handleDelete(awb)} // Delete this AWB when clicked
>
  <i className="fa fa-trash" />
</a>
</div>

              ))}
           </div> 

           <a onClick={doBulkScan} style={buttonsyle} type="button" className="btn-demo add">
                                            Submit
                                        </a>
                                        <p style={{whiteSpace:'pre-line'}}>{msg}</p>
    </div>

    
  )}

</div>



            </div>
            <p style={{color:'red'}}>{errorMsg}</p>
        </div>

     
    </div>
  );
};

export default BulkScan;
